webpackJsonp([273950069227526],{

/***/ 264:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"html":"<p>The content folder is where all your information for dynamic pages lives.</p>\n<p>You can create markdown files in here and use that data in other pages.</p>\n<p>The <code>templateKey</code> field above tells Gatsby which template in your <code>src/templates</code> folder to use when turning this markdown file into an actual page.</p>\n<p>You might just want to use dynamic pages for blog posts anyways and not use markdown files for other pages. To just create normal pages, you can do things like in <code>src/pages/page-2.js</code>.</p>\n<p>You can add content in the <code>frontmatter</code> part of file like lists if you want to be able to place content within more complex styles.\nThis list below isn’t actually part of the markdown.</p>","frontmatter":{"path":"/about","title":"About Dynamic Pages","exampleList":[{"text":"list item one"},{"text":"list item two"},{"text":"list item three"},{"text":"list item four"}]}}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---about-9740f329b8888c8b3440.js